"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineLexer = exports.Lexer = void 0;
const lexer_1 = __importDefault(require("./lexer"));
exports.Lexer = lexer_1.default;
const inline_1 = __importDefault(require("./inline"));
exports.InlineLexer = inline_1.default;
const parser_1 = __importDefault(require("./parser"));
const defaults_1 = __importDefault(require("./defaults"));
function parse(src, options) {
    options = { ...defaults_1.default, ...options };
    if (!!options.contentSizeLimit && src.length > options.contentSizeLimit) {
        const limitError = new Error('Markdown content size limit reached');
        limitError.code = 'CONTENT_SIZE_LIMIT_REACHED';
        throw limitError;
    }
    const lexer = new lexer_1.default(options);
    const parser = new parser_1.default(options);
    const tokens = lexer.lex(src);
    const result = parser.parse(tokens);
    return result.replace(/\n$/, '');
}
exports.default = parse;
